import { Timestamp } from "firebase/firestore";

export class Absence {
    /** @type {string} */
    employeeId: string = "";

    /** @type {Date} */
    startDate: Timestamp | null;

    /** @type {Date} */
    endDate: Timestamp | null; // Friday of the week


    /** @type {boolean} */
    fullDay: boolean = true;

    /**
     * Create a new absence
     * @param {Object} param0 The assignment demand parameters
     * @param {string} param0.employeeId The id of employee
     * @param {string} param0.startDate The start date of the absence
     * @param {string} param0.endDate The end date of the absence
     * @param {boolean} param0.isFullDay Whether the absence is full-day or half-day
     */
    constructor(employeeId = "", startDate: Timestamp | null = null, endDate: Timestamp | null = null, fullday = true) {
        this.employeeId = employeeId;
        this.startDate = startDate;
        this.endDate = endDate;
        this.fullDay = fullday;
    }
}
